import {
    Avatar,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Typography,
    Box,
    Tooltip,
    Button,
} from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import { useContext, Context } from "../../Context";
import EditIcon from "@mui/icons-material/Edit";
import ChangePassword from "../../components/ChangePassword";
import ChangeUsername from "../../components/ChangeUsername";
import ChangeEmail from "../../components/ChangeEmail";
import MessageModal from "../../components/MessageModal";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmModal from "../../components/ConfirmModal";
import UploadImage from "../../components/UploadImage";
import Zoom from "@mui/material/Zoom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { URL, origin } from "../../config";

export default function UserDetails() {
    const { userName } = useContext(Context);
    const [open, setOpen] = React.useState(false);
    const [openUserName, setOpenUserName] = React.useState(false);
    const [openEmail, setOpenEmail] = React.useState(false);
    const [error, setError] = React.useState("");
    const [userInfo, setUserInfo] = React.useState();
    const [openConfirm, setOpenConfirm] = React.useState(false);
    const [openConfirmDltAcc, setOpenConfirmDltAcc] = React.useState(false);
    const [openImageUpload, setOpenUploadImage] = React.useState(false);
    const [alert, setAlert] = React.useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        fetch(`${URL}/user?` + new URLSearchParams({ username: userName }), {
            method: "GET",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": "application/json",
                Origin: `${origin}`,
            },
        })
            .then(async (response) => {
                return {
                    data: await response.json(),
                    code: response.status,
                };
            })
            .then((data) => {
                if (data.code !== 200) {
                    navigate(`/${data.code}`);
                    setError(data.data.message);
                    throw new Error(data.data.message);
                } else {
                    setUserInfo(data.data);
                }
            });
    }, []);

    const deleteEmail = () => {
        fetch(`${URL}/remove/email`, {
            method: "DELETE",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": `application/json`,
                Origin: `${origin}`,
            },
        })
            .then((response) => {
                console.log(response);
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    navigate(`/${data.code}`);
                    setError(data.error.message);
                    throw new Error(data.error.message);
                }
            })
            .then((response) => {
                setUserInfo(response);
            })
            .catch((err) => console.log(err));
        closeConfirmModal();
    };

    const deleteAccount = () => {
        fetch(`http://localhost:5001/user/delete`, {
            method: "DELETE",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": `application/json`,
                Origin: `http://localhost:3000}`,
            },
        })
            .then((response) => {
                console.log(response);
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    navigate(`/${data.code}`);
                    setError(data.error.message);
                    throw new Error(data.error.message);
                }
            })
            .then((response) => {
                setUserInfo(response);
            })
            .catch((err) => console.log(err));
        navigate("/");
    };

    const closeAlertEmail = () => {
        setAlert(false);
    };

    const openPassPage = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const editUser = () => {
        setOpenUserName(true);
    };

    const closeEditUser = () => {
        setOpenUserName(false);
    };

    const closeEditEmail = () => {
        setOpenEmail(false);
    };

    const openEditEmail = () => {
        setOpenEmail(true);
    };

    const closeAlert = () => {
        setError("");
    };

    const openConfirmModal = () => {
        setOpenConfirm(true);
    };

    const closeConfirmModal = () => {
        setOpenConfirm(false);
    };

    const openConfirmDeleteAccount = () => {
        setOpenConfirmDltAcc(true);
    };

    const closeConfirmDelteAccount = () => {
        setOpenConfirmDltAcc(false);
    };

    const closeUploadImage = () => {
        setOpenUploadImage(false);
    };

    const openUploadImage = () => {
        setOpenUploadImage(true);
    };

    return (
        <>
            <Container
                maxWidth="md"
                sx={{
                    my: 4,
                    py: 3,
                    borderRadius: 2,
                    boxShadow: 24,
                    backgroundColor: "primary.main",
                    "@media (max-width: 75em)": {
                        width: "80%",
                    },
                }}
            >
                <Container
                    sx={{
                        width: "100%",
                        display: "flex",
                        "@media (max-width: 75em)": {
                            width: "80%",
                            display: "flex",
                            flexDirection: "column-reverse",
                        },
                    }}
                >
                    <Box minWidth="50%" color={"primary.contrastText"}>
                        <Typography variant="h6">
                            Your current details
                        </Typography>
                        <List sx={{ width: "100%" }}>
                            <ListItem divider disablePadding>
                                <ListItemText
                                    secondaryTypographyProps={{}}
                                    secondary={
                                        userInfo ? ` ${userInfo.username}` : ""
                                    }
                                    primary={"Username"}
                                    sx={{ my: 1 }}
                                />
                                <IconButton onClick={editUser}>
                                    <EditIcon color={"grey"} />
                                </IconButton>
                            </ListItem>
                            <ListItem divider disablePadding>
                                <ListItemText
                                    primary="Change your password"
                                    sx={{ my: 2 }}
                                />
                                <IconButton onClick={openPassPage}>
                                    <EditIcon color={"grey"} />
                                </IconButton>
                            </ListItem>
                            <ListItem divider disablePadding>
                                <ListItemText
                                    secondaryTypographyProps={{}}
                                    primary={"Email"}
                                    secondary={
                                        userInfo
                                            ? userInfo.email
                                                ? ` ${userInfo.email}`
                                                : "Email not set, set an email for password recovery"
                                            : "Email not set, set an email for password recovery"
                                    }
                                    sx={{ my: 2 }}
                                />
                                <IconButton onClick={openConfirmModal}>
                                    {userInfo ? (
                                        userInfo.email ? (
                                            <DeleteIcon />
                                        ) : (
                                            <></>
                                        )
                                    ) : (
                                        <></>
                                    )}
                                </IconButton>
                                <IconButton onClick={openEditEmail}>
                                    <EditIcon color={"grey"} />
                                </IconButton>
                            </ListItem>
                            <ListItem divider disablePadding>
                                <ListItemText
                                    primary="Delete your account"
                                    secondary="Permamently delete your account (cannot be undone)"
                                />
                                <Button
                                    color="error"
                                    variant="outlined"
                                    onClick={openConfirmDeleteAccount}
                                >
                                    Delete
                                </Button>
                            </ListItem>
                        </List>
                    </Box>
                    <Box
                        marginLeft={3}
                        minWidth="50%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Tooltip
                            title="edit picture"
                            arrow
                            TransitionComponent={Zoom}
                            followCursor
                        >
                            <IconButton
                                sx={{ "&:hover": { color: "black" } }}
                                onClick={openUploadImage}
                            >
                                <Avatar
                                    src={userInfo ? userInfo.imgurl : ""}
                                    sx={{ height: "150px", width: "150px" }}
                                ></Avatar>
                            </IconButton>
                        </Tooltip>
                    </Box>

                    {/* pop up modals */}
                    <UploadImage
                        open={openImageUpload}
                        onClose={closeUploadImage}
                        delete={
                            userInfo ? (userInfo.imgurl ? true : false) : false
                        }
                    />
                    <ChangePassword onClose={handleClose} open={open} />
                    <ChangeUsername
                        onClose={closeEditUser}
                        open={openUserName}
                    />
                    <ChangeEmail onClose={closeEditEmail} open={openEmail} />
                </Container>
                <MessageModal
                    severity="error"
                    title="error"
                    open={Boolean(error ? true : false)}
                    onClose={closeAlert}
                >
                    {error}
                </MessageModal>
                <ConfirmModal
                    onConfirm={deleteEmail}
                    open={openConfirm}
                    onClose={closeConfirmModal}
                >
                    Are you sure you want to delete email?
                </ConfirmModal>
                <ConfirmModal
                    onConfirm={deleteAccount}
                    open={openConfirmDltAcc}
                    onClose={closeConfirmDelteAccount}
                >
                    Are you sure you want to delete your account
                </ConfirmModal>
                <MessageModal
                    severity="success"
                    title="success"
                    open={alert}
                    onClose={closeAlertEmail}
                >
                    Email deleted
                </MessageModal>
            </Container>
        </>
    );
}
